import React, { Component } from 'react'

export class FutureTop extends Component {
    render() {
        return (
            <div className='future__top'>
                {/* Future title */}
                <h3 className='future__title'>Modern Technology</h3>
                {/* Future sub-title */}
                <h4 className='future__title--sub'>More than just a drone company</h4>
            </div>
        )
    }
}

export default FutureTop